import styled from 'styled-components';

export const PopupContainer = styled.div`
  text-align: left;
  position: absolute;
  top: ${props => props.theme.space['2.5']} !important;
  right: ${props => props.theme.space['1.0']} !important;
  width: max-content;
  background-color: white;
  box-shadow: ${props => props.theme.shadows.dp12} !important;
  border-radius: ${props => props.theme.space['0.3']} !important;
  z-index: 1;

  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.space.s4} 0 !important;
`;

export const PopupButtonText = styled.span`
  font-family: ${props => props.theme.fonts.circular} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  ${props => props.theme.mediaQueries.smallDown} {
    font-size: ${props => props.theme.fontSizes.small} !important;
  }
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  float: left;
  padding-right: ${props => props.theme.space['2.0']};
`;

export const PopupButton = styled.button`
  background-color: transparent;
  border: none;
  &:focus {
    background-color: ${props => props.theme.colors.capsuleGray00} !important;
  }

  outline: none;
  cursor: pointer;
  box-sizing: border-box;

  padding: ${props => props.theme.space['1.0']} ${props => props.theme.space['2.0']};
`;
